import { showToast } from 'stores/ToastStore';
import i18next from 'i18next';
const setStripeKey = () => {
    // Set Stripe keys to allow billing actions
    Stripe.setPublishableKey(STRIPE_KEY);
};
export const onCreateCreditCard = (payload) => {
    setStripeKey();
    return new Promise((resolve, reject) => {
        Stripe.card.createToken({
            number: payload.number,
            cvc: payload.cvv,
            exp_month: payload.expiry_month,
            exp_year: payload.expiry_year,
        }, (_, response) => {
            if (response.error) {
                showToast(i18next.t('ERROR_GETTING_CARD_TOKEN'), '', 'error');
                showToast(i18next.t('CREDIT_CARD_NOT_UPDATED'), '', 'error');
                reject();
            }
            resolve(response);
        });
    });
};
